import React from 'react';
import { Navigate } from 'react-router-dom';
import '../utils/ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const expiration = localStorage.getItem('expiration');

  // Si no hay token, redirige al login
  if (!token) return <Navigate to="/quienes-somos" replace />;

  // Si el token expiró, limpia todo y redirige al login
  if (expiration) {
    const now = new Date();
    const expDate = new Date(expiration);
    if (now > expDate) {
      localStorage.clear();
      return <Navigate to="/login" replace />;
    }
  }

  // Si todo está bien, renderiza el contenido protegido
  return children;
};

export default ProtectedRoute;
